import { render, staticRenderFns } from "./VesselCrewList.vue?vue&type=template&id=194c858c&scoped=true&"
import script from "./VesselCrewList.vue?vue&type=script&lang=js&"
export * from "./VesselCrewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c858c",
  null
  
)

export default component.exports